module.exports = __webpack_public_path__ + "static/media/lidcore-mockup-3.0964bf13.jpg";